module.exports = __webpack_public_path__ + "static/media/8.f7c526c7.svg";